import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../contexts';
import { useAggregatedState } from '../../../../helpers';

export const SapInitiativesContext = React.createContext(null);

const { Provider } = SapInitiativesContext;
export const SapInitiativesProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [ state, setState ] = useAggregatedState({
        isLoadingUploadArea: false,
        updatedValues: null
    });

    const importActualAsync = async (data) => {
        try {
            setState({ isLoadingUploadArea: true });
            const importValuesApi = await fetchAuthorized(ApiRoutes.Projects.ImportProjectsValues(),
            {                    
                method: HttpMethods.POST,
                body: JSON.stringify(data),
                collectErrorDetails: true
            }); 
    
            const updatedValues = await importValuesApi.json();
            setState({ updatedValues, isLoadingUploadArea: false });
          }
    
          catch (ex){
            setState({ isLoadingUploadArea: false });
            console.error(ex);
            console.error(ex.details);
          }
    }

    return (
        <Provider value={{
            state,
            importActualAsync
        }}>
            {props.children}
        </Provider>
    );
}